"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3126],{

/***/ 99028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SidebarMenuPMD_SidebarMenuPMD; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/SidebarMenuPMD.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;



var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: 48px;\n"])));
var Content = styled_components_browser_esm["default"].nav(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0 8px;\n"])));
var IconWrapper = styled_components_browser_esm["default"].span(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background-color: ", ";\n  box-shadow: ", " 0 0 0 1px inset;\n  width: 25px;\n  height: 25px;\n"])), function (props) {
  return (0,build_esm.themeGet)('radii.circle')(props);
}, function (props) {
  return (0,build_esm.getPaletteColor)('base')(props);
}, function (props) {
  return (0,build_esm.getPaletteColor)('background.whisper')(props);
});
var LoginButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n\n  label {\n    font-weight: ", ";\n  }\n\n  &:hover {\n    label {\n      font-weight: ", ";\n    }\n  }\n"])), function (props) {
  return (0,build_esm.getPaletteColor)('pmd.base')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontWeights.regular')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontWeights.medium')(props);
});
var LogoutLink = (0,styled_components_browser_esm["default"])(atoms/* Link */.rU).attrs(function () {
  return {
    color: 'primary.base',
    marginBottom: -5,
    marginLeft: -8,
    marginRight: -8,
    paddingBottom: 5,
    paddingTop: 3
  };
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var RegisterLink = (0,styled_components_browser_esm["default"])(LogoutLink)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: transparent;\n  color: ", ";\n  margin-bottom: 16px;\n  padding: 0;\n"])), (0,build_esm.themeGet)('colors.white'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/SidebarLoginHeading.js





var SidebarLoginHeading = function SidebarLoginHeading(_ref) {
  var storeName = _ref.storeName,
    theme = _ref.theme,
    cartUrl = _ref.cartUrl,
    domain = _ref.domain;
  return react.createElement(atoms/* Flex */.kC, {
    bg: theme.palette.primary.base,
    alignItems: "center",
    "data-testid": "sidebar-heading-pmd",
    flexDirection: "column",
    p: "16px",
    width: "100%"
  }, react.createElement(atoms/* Flex */.kC, {
    alignItems: "center",
    mb: "16px",
    width: "100%",
    justifyContent: "center",
    p: "8px 0"
  }, react.createElement(IconWrapper, {
    radii: "50%"
  }, react.createElement(esm/* Icon */.JO$, {
    name: "Person",
    fill: "text.white"
  })), react.createElement(atoms/* Text */.xv, {
    alignText: "center",
    color: "text.white",
    ml: "8px",
    fontSize: 3
  }, "Bem vindo! :)")), react.createElement(LoginButton, {
    forwardedAs: "a",
    full: true,
    mb: "10px",
    href: "".concat(cartUrl, "#/identificacao?next=").concat(domain, "/").concat(storeName, "&origin=magazinevoce"),
    customColor: {
      "default": '#ffffff',
      hover: theme.palette.primary.base
    },
    invertedColors: true
  }, "Entrar como cliente"), react.createElement(atoms/* Button */.zx, {
    as: "a",
    variation: "outline",
    full: true,
    customColor: {
      "default": '#ffffff',
      hover: '#ffffff'
    },
    href: "".concat(domain, "/login/"),
    mb: "16px"
  }, "Entrar como influenciador"), react.createElement(RegisterLink, {
    bg: "primary",
    "data-testid": "register-link",
    href: "".concat(cartUrl, "#/identificacao?next=").concat(domain, "/").concat(storeName, "&origin=magazinevoce"),
    textAlign: "center",
    underline: false,
    underlineOnHover: true
  }, "ou cadastre-se"));
};
SidebarLoginHeading.defaultProps = {
  cartUrl: '',
  domain: '',
  storeName: '',
  theme: {}
};
 false ? 0 : void 0;
/* harmony default export */ var SidebarMenuPMD_SidebarLoginHeading = (SidebarLoginHeading);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/SidebarHeading.js





var SidebarHeading = function SidebarHeading(_ref) {
  var _data$helpers;
  var data = _ref.data,
    cartUrl = _ref.cartUrl,
    domain = _ref.domain,
    accountData = _ref.accountData,
    storeName = _ref.storeName,
    onMenuHeaderClick = _ref.onMenuHeaderClick,
    promoterData = _ref.promoterData,
    theme = _ref.theme;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    loggedInfo = _useState2[0],
    setLoggedInfo = _useState2[1];
  (0,react.useEffect)(function () {
    if (promoterData == null ? void 0 : promoterData.store) {
      setLoggedInfo({
        label: data.promoterLabel,
        url: data.loggedUrl
      });
    } else {
      setLoggedInfo({
        label: data.label,
        url: data.customerLoggedUrl
      });
    }
  }, [data, promoterData]);
  return react.createElement(atoms/* Box */.xu, {
    bg: "background.primary",
    "data-testid": "sidebar-header",
    mb: 2
  }, !(accountData == null ? void 0 : accountData.name) && !(promoterData == null ? void 0 : promoterData.store) ? react.createElement(SidebarMenuPMD_SidebarLoginHeading, {
    storeName: storeName,
    theme: theme,
    cartUrl: cartUrl,
    domain: domain
  }) : react.createElement(react.Fragment, null, react.createElement(atoms/* Item */.ck, {
    scale: "medium",
    endIcon: "ChevronRight",
    fontWeight: "medium",
    variant: "primary",
    as: "a",
    href: loggedInfo == null ? void 0 : loggedInfo.url,
    rel: data == null ? void 0 : data.rel
  }, loggedInfo == null ? void 0 : loggedInfo.label), !(promoterData == null ? void 0 : promoterData.store) && (accountData == null ? void 0 : accountData.name) && react.createElement(atoms/* Box */.xu, {
    bg: "background.primary"
  }, data == null ? void 0 : (_data$helpers = data.helpers) == null ? void 0 : _data$helpers.map(function (item) {
    return react.createElement(atoms/* Item */.ck, {
      key: item == null ? void 0 : item.url,
      href: item == null ? void 0 : item.url,
      rel: item == null ? void 0 : item.rel,
      color: "white",
      startIcon: item == null ? void 0 : item.id,
      onClick: function onClick(e) {
        return onMenuHeaderClick(e, item);
      }
    }, item == null ? void 0 : item.label);
  }))));
};
SidebarHeading.defaultProps = {
  accountData: {},
  cartUrl: '',
  domain: '',
  promoterData: {},
  storeName: '',
  theme: {}
};
 false ? 0 : void 0;
/* harmony default export */ var SidebarMenuPMD_SidebarHeading = (SidebarHeading);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/SidebarMenuPMD.js


var _excluded = ["data", "storeName", "structure"];







function SidebarMenuPMD(_ref) {
  var _structure$cookies, _structure$cookies2, _structure$config, _structure$config$car, _structure$config2, _categoryList$list, _categoryList$list2, _structure$cookies3, _structure$cookies4, _structure$cookies5, _structure$cookies5$p, _structure$cookies6, _structure$cookies6$a;
  var data = _ref.data,
    storeName = _ref.storeName,
    structure = _ref.structure,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _ref2 = data || {},
    categoryList = _ref2.categoryList,
    header = _ref2.header,
    account = _ref2.account;
  var onCollapsedClick = props.onCollapsedClick,
    onMenuItemClick = props.onMenuItemClick,
    onMenuHeaderClick = props.onMenuHeaderClick;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var handleCollapsed = function handleCollapsed() {
    onCollapsedClick();
    setCollapsed(!collapsed);
  };
  return react.createElement(Container, {
    "data-testid": "sidebarmenu-pmd-container"
  }, header && react.createElement(SidebarMenuPMD_SidebarHeading, {
    accountData: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData,
    data: header,
    storeName: storeName,
    onMenuHeaderClick: onMenuHeaderClick,
    promoterData: structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.promoterData,
    theme: structure.theme,
    cartUrl: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : (_structure$config$car = _structure$config.cartUrl) == null ? void 0 : _structure$config$car["default"],
    domain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.domain
  }), react.createElement(Content, null, (categoryList == null ? void 0 : (_categoryList$list = categoryList.list) == null ? void 0 : _categoryList$list.length) && react.createElement(atoms/* Box */.xu, {
    bg: "white",
    borderRadius: 4
  }, react.createElement(molecules/* List.Collapse */.aV.Collapse, {
    trigger: collapsed,
    collapsedIn: categoryList == null ? void 0 : categoryList.show,
    renderAction: collapsed && react.createElement(molecules/* List.Action */.aV.Action, {
      endIcon: "ChevronDown",
      fontWeight: "medium",
      onClick: handleCollapsed
    }, categoryList == null ? void 0 : categoryList.collapseText),
    divided: true,
    "data-testid": "category-list"
  }, categoryList == null ? void 0 : (_categoryList$list2 = categoryList.list) == null ? void 0 : _categoryList$list2.map(function (item) {
    return react.createElement(molecules/* List.Item */.aV.Item, {
      key: item == null ? void 0 : item.id,
      as: "a",
      href: item == null ? void 0 : item.url,
      rel: item == null ? void 0 : item.rel,
      startIcon: (item == null ? void 0 : item.id) ? "Category".concat(item == null ? void 0 : item.id) : undefined,
      onClick: function onClick(e) {
        return onMenuItemClick(e, item, 'departamento:');
      },
      fill: "background.primary"
    }, item == null ? void 0 : item.label);
  }))), ((structure == null ? void 0 : (_structure$cookies3 = structure.cookies) == null ? void 0 : _structure$cookies3.accountData) || (structure == null ? void 0 : (_structure$cookies4 = structure.cookies) == null ? void 0 : _structure$cookies4.promoterData)) && react.createElement(LogoutLink, {
    "data-testid": "logout-link",
    href: account == null ? void 0 : account.signOutUrl,
    bg: "primary",
    underlineOnHover: false,
    textAlign: "center",
    underline: true,
    mt: 4,
    py: 3
  }, react.createElement("span", null, "N\xE3o \xE9 ".concat((structure == null ? void 0 : (_structure$cookies5 = structure.cookies) == null ? void 0 : (_structure$cookies5$p = _structure$cookies5.promoterData) == null ? void 0 : _structure$cookies5$p.name) || (structure == null ? void 0 : (_structure$cookies6 = structure.cookies) == null ? void 0 : (_structure$cookies6$a = _structure$cookies6.accountData) == null ? void 0 : _structure$cookies6$a.name), "? Sair")))));
}
SidebarMenuPMD.defaultProps = {
  storeName: '',
  structure: {}
};
 false ? 0 : void 0;
SidebarMenuPMD.ssr = true;
SidebarMenuPMD.displayName = 'SidebarMenuPMD';
/* harmony default export */ var SidebarMenuPMD_SidebarMenuPMD = ((0,withLayoutProps/* default */.Z)(SidebarMenuPMD));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/index.js


/***/ }),

/***/ 94373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SimpleHeader_SimpleHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/index.js + 1 modules
var Logo = __webpack_require__(15566);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js + 2 modules
var Strip = __webpack_require__(85737);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeader/SimpleHeader.styles.js

var _templateObject, _templateObject2, _templateObject3;



var Container = styled_components_browser_esm["default"].header(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 75px;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 0 10px;\n"])), function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.primary')(props);
});
var ContainerLogo = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 19px 12px;\n"])));
var StripHeader = (0,styled_components_browser_esm["default"])(Strip/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  width: calc(100% - 20px);\n"])), function (props) {
  return (0,utils/* themeGet */.R)('radii.small')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('radii.small')(props);
});

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeader/SimpleHeader.js




var SimpleHeader = function SimpleHeader() {
  return react.createElement(Container, null, react.createElement(ContainerLogo, {
    onClick: function onClick() {
      (0,esm/* routePush */.dY)({
        path: '/',
        spa: true
      });
    },
    "data-testid": "container-logo"
  }, react.createElement(Logo/* default */.Z, {
    width: 137,
    height: 29
  })), react.createElement(StripHeader, {
    size: 6
  }));
};
/* harmony default export */ var SimpleHeader_SimpleHeader = (SimpleHeader);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeader/index.js


/***/ }),

/***/ 36037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleHeaderPMD_SimpleHeaderPMD; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/index.js + 1 modules
var Logo = __webpack_require__(15566);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/index.js + 13 modules
var PromoterHeader = __webpack_require__(43392);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js + 2 modules
var Strip = __webpack_require__(85737);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeaderPMD/SimpleHeaderPMD.styles.js

var _templateObject, _templateObject2, _templateObject3;




var Container = styled_components_browser_esm["default"].header(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 76px;\n  background-color: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n"])), function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.primary')(props);
});
var GridContent = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-content: center;\n"])));
var StripHeader = (0,styled_components_browser_esm["default"])(Strip/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  && {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    width: 100%;\n    position: static;\n  }\n"])), function (props) {
  return (0,utils/* themeGet */.R)('radii.small')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('radii.small')(props);
});

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeaderPMD/SimpleHeaderPMD.js








var SimpleHeaderPMD = function SimpleHeaderPMD(_ref) {
  var _structure$cookies, _data$channel, _data$channel$data, _data$channel$data$, _data$channel$data$$v, _structure$cookies2, _data$channel2, _data$channel2$data, _data$channel2$data$, _data$channel2$data$$, _promoterProfile$valu, _config$publicRuntime, _config$publicRuntime2;
  var structure = _ref.structure,
    data = _ref.data,
    config = _ref.config;
  var mvcShowcaseName = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.mvcShowcaseName;
  var promoterProfile = (0,esm.usePromoterProfile)({
    storeId: mvcShowcaseName
  }).promoterProfileData;
  var storeName = (data == null ? void 0 : (_data$channel = data.channel) == null ? void 0 : (_data$channel$data = _data$channel.data) == null ? void 0 : (_data$channel$data$ = _data$channel$data[1]) == null ? void 0 : (_data$channel$data$$v = _data$channel$data$.value) == null ? void 0 : _data$channel$data$$v.name) || (structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.mvcShowcaseName) || '';
  var storeAvatar = (data == null ? void 0 : (_data$channel2 = data.channel) == null ? void 0 : (_data$channel2$data = _data$channel2.data) == null ? void 0 : (_data$channel2$data$ = _data$channel2$data[2]) == null ? void 0 : (_data$channel2$data$$ = _data$channel2$data$.value) == null ? void 0 : _data$channel2$data$$.avatar) || (promoterProfile == null ? void 0 : (_promoterProfile$valu = promoterProfile.value) == null ? void 0 : _promoterProfile$valu.avatar) || '';
  var baseUrl = config == null ? void 0 : (_config$publicRuntime = config.publicRuntimeConfig) == null ? void 0 : (_config$publicRuntime2 = _config$publicRuntime.parceiromagalu) == null ? void 0 : _config$publicRuntime2.domain;
  return react.createElement(react.Fragment, null, react.createElement(Container, null, react.createElement(Grid/* default */.Z, {
    gridTemplateColumns: "minmax(8px, 1fr) minmax(auto, 1366px) minmax(8px, 1fr)",
    gridTemplateRows: "71px 5px",
    gridTemplateAreas: " '. content .' '. strip .'",
    "data-testid": "promoter-header-minimal"
  }, react.createElement(GridContent, {
    gridArea: "content",
    onClick: function onClick() {
      (0,build_esm/* routePush */.dY)({
        path: "".concat(baseUrl, "/magazine").concat(storeName, "/"),
        spa: true
      });
    },
    "data-testid": "container-logo"
  }, react.createElement(Logo/* default */.Z, {
    width: 138,
    height: 30
  })), react.createElement(Grid/* default */.Z, {
    gridArea: "strip"
  }, react.createElement(StripHeader, {
    size: 5
  })))), react.createElement(PromoterHeader/* default */.Z, {
    "static": {
      headerType: 'minimal',
      store: {
        image: storeAvatar,
        name: storeName
      }
    },
    structure: structure
  }));
};
 false ? 0 : void 0;
SimpleHeaderPMD.ssr = true;
SimpleHeaderPMD.displayName = 'SimpleHeaderPMD';
/* harmony default export */ var SimpleHeaderPMD_SimpleHeaderPMD = (SimpleHeaderPMD);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SimpleHeaderPMD/index.js


/***/ }),

/***/ 83174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Skeleton/Skeleton.styles.js

var _templateObject;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  width: ", ";\n  position: relative;\n  display: block;\n  @keyframes pulse {\n    50% {\n      opacity: 0.5;\n    }\n  }\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  background-size: cover;\n  background-repeat: repeat;\n"])), function (_ref) {
  var height = _ref.height;
  return height && height.trim() !== '' ? height : '0px';
}, function (_ref2) {
  var width = _ref2.width;
  return width && width.trim() !== '' ? width : '0px';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Skeleton/Skeleton.js





var SVG_XMLS = 'http://www.w3.org/2000/svg';
var Skeleton = function Skeleton(_ref) {
  var config = _ref.config,
    containerHeight = _ref.height,
    containerWidth = _ref.width;
  var skeletonRef = (0,react.useRef)(null);
  var color = (config == null ? void 0 : config.color) || '#D3DADD';
  react.useEffect(function () {
    if (esm/* whereAmI.onClient */.er.onClient && skeletonRef.current) {
      var svg = document.createElementNS(SVG_XMLS, 'svg');
      svg.setAttribute('xmlns', SVG_XMLS);
      svg.setAttribute('width', '100%');
      svg.setAttribute('viewBox', '0 0 1365 1365');
      config.body.forEach(function (row) {
        var _row = (0,slicedToArray/* default */.Z)(row, 1),
          _row$ = _row[0],
          height = _row$.height,
          _row$$radius = _row$.radius,
          radius = _row$$radius === void 0 ? 0 : _row$$radius,
          width = _row$.width,
          x = _row$.x,
          y = _row$.y;
        var skeletonColor = color.replace('#', '%23');
        var rect = document.createElementNS(SVG_XMLS, 'rect');
        rect.setAttribute('width', String(width));
        rect.setAttribute('height', String(height));
        rect.setAttribute('x', String(x));
        rect.setAttribute('y', String(y));
        rect.setAttribute('rx', String(radius));
        rect.setAttribute('fill', skeletonColor);
        svg.appendChild(rect);
      });
      var svgHtml = "data:image/svg+xml,".concat(svg.outerHTML.toString());
      skeletonRef.current.setAttribute('style', "\n          background-image: url('".concat(svgHtml, "');\n        "));
    }
  }, []);
  return react.createElement(Container, {
    "data-testid": "skeleton",
    height: containerHeight,
    width: containerWidth,
    ref: skeletonRef
  });
};
Skeleton.defaultProps = {
  config: {
    body: []
  },
  height: '0px',
  width: '0px'
};
 false ? 0 : void 0;
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Skeleton/index.js


/***/ }),

/***/ 89084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SocialShare_SocialShare; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/index.js + 2 modules
var molecules_SocialShare = __webpack_require__(51382);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SocialShare/SocialShare.utils.js

var parseData = function parseData() {
  var _structure$route;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var structure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hasStoreId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.storeId;
  var _data$url = data.url,
    url = _data$url === void 0 ? '' : _data$url,
    _data$title = data.title,
    title = _data$title === void 0 ? '' : _data$title,
    _data$description = data.description,
    description = _data$description === void 0 ? '' : _data$description,
    _data$domain = data.domain,
    domain = _data$domain === void 0 ? '' : _data$domain,
    _data$linksParameter = data.linksParameter,
    linksParameter = _data$linksParameter === void 0 ? '' : _data$linksParameter;
  var txtUrl = hasStoreId ? "".concat(domain).concat(url) : "".concat(domain, "/").concat(url);
  var txtTitle = encodeURIComponent(title);
  var txtDesc = encodeURIComponent((0,utils_build_esm/* cleanHtml */.ZF)(description));
  var witLinksParameter = "".concat(txtUrl).concat(encodeURIComponent(linksParameter));
  return {
    urlFacebook: "https://www.facebook.com/sharer/sharer.php?u=".concat(witLinksParameter),
    urlMail: "mailto:?subject=".concat(txtTitle, "&body=").concat(txtDesc, "%20").concat(witLinksParameter),
    urlTwitter: "https://twitter.com/intent/tweet?text=".concat(txtTitle, "&url=").concat(witLinksParameter),
    urlWhatsApp: "https://wa.me/?text=".concat(witLinksParameter)
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SocialShare/SocialShare.js







var SocialShare = function SocialShare(_ref) {
  var _structure$config;
  var data = _ref.data,
    structure = _ref.structure,
    _ref$static = _ref["static"],
    socialItemsProps = _ref$static.items,
    _ref$static$hiddenIte = _ref$static.hiddenItems,
    hiddenItems = _ref$static$hiddenIte === void 0 ? [] : _ref$static$hiddenIte,
    linksParameter = _ref$static.linksParameter,
    staticDomain = _ref$static.domain;
  var _data$product = data == null ? void 0 : data.product,
    title = _data$product.title,
    description = _data$product.description,
    url = _data$product.path,
    variationId = _data$product.variationId;
  var domain = staticDomain || (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.domain);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleShareClick = function handleShareClick(e, item) {
    publish('product:share', {
      iconName: item,
      variationId: variationId
    });
  };
  var links = parseData({
    description: description,
    domain: domain,
    linksParameter: linksParameter,
    title: title,
    url: url
  }, structure);
  var socialItems = socialItemsProps.filter(function (item) {
    return !hiddenItems.includes(item.title);
  }).map(function (_ref2) {
    var icon = _ref2.icon,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? '#fff' : _ref2$color,
      itemTitle = _ref2.title,
      urlPath = _ref2.url;
    return {
      Icon: react.createElement(esm/* Icon */.JO$, {
        name: icon,
        color: color
      }),
      title: itemTitle,
      url: links == null ? void 0 : links[urlPath]
    };
  });
  return react.createElement(molecules_SocialShare/* default */.Z, {
    socialItems: socialItems,
    onItemClick: function onItemClick(e, item) {
      return handleShareClick(e, item);
    }
  });
};
SocialShare.defaultProps = {
  data: {
    product: {}
  },
  "static": {
    hiddenItems: [],
    items: [],
    linksParameter: ''
  },
  structure: {
    config: {},
    route: {}
  }
};
 false ? 0 : void 0;
SocialShare.ssr = false;
/* harmony default export */ var SocialShare_SocialShare = ((0,withLayoutProps/* default */.Z)(SocialShare));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SocialShare/index.js


/***/ }),

/***/ 72803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SubCategoryList_SubCategoryList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SubCategoryList/SubCategoryList.styles.js

var _templateObject;


var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SubCategoryList/SubCategoryList.js











function SubCategoryList() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    data = _ref.data,
    staticProps = _ref["static"];
  var _ref2 = staticProps || {},
    _ref2$basePath = _ref2.basePath,
    basePath = _ref2$basePath === void 0 ? '' : _ref2$basePath,
    _ref2$spa = _ref2.spa,
    spa = _ref2$spa === void 0 ? false : _ref2$spa,
    _ref2$show = _ref2.show,
    show = _ref2$show === void 0 ? 3 : _ref2$show,
    label = _ref2.label;
  var _ref3 = (data == null ? void 0 : data.category) || [],
    _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
    _ref4$ = _ref4[0],
    category = _ref4$ === void 0 ? {} : _ref4$;
  var _category$subcategori = category.subcategories,
    subcategories = _category$subcategori === void 0 ? [] : _category$subcategori;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleClick = function handleClick(_ref5) {
    var event = _ref5.event,
      type = _ref5.type,
      subcategory = _ref5.subcategory;
    publish("".concat(type, ":click"), {
      eventLabel: (0,utils_build_esm/* slug */.oF)(subcategory == null ? void 0 : subcategory.label)
    });
    if (spa) {
      event.preventDefault();
      var path = subcategory.path;
      (0,utils_build_esm/* routePush */.dY)({
        path: "".concat(basePath).concat(path),
        spa: spa
      });
    }
  };
  var handleClickSideBar = function handleClickSideBar() {
    setVisible(!visible);
    publish('subcategoryfulllist:click');
  };
  var subCategoryList = subcategories.map(function (sub) {
    return (0,utils_build_esm/* buildSubcategoryPath */.ey)(sub, category);
  });
  var subCateList = subCategoryList.slice(0, show);
  return !!subcategories.length && react.createElement(Container, {
    "data-testid": "sub-category-list"
  }, react.createElement(List/* default */.Z, null, react.createElement(List/* default.Header */.Z.Header, {
    titleAs: "h1"
  }, label || (category == null ? void 0 : category.label)), subcategories && subCateList.map(function (sub, index) {
    return react.createElement(List/* default.Item */.Z.Item, {
      key: sub.label,
      fontSize: 1,
      onClick: function onClick(ev) {
        handleClick({
          event: ev,
          subcategory: sub,
          type: 'subcategorytop'
        });
      },
      inset: true,
      testId: "sub-category-list-item-".concat(index)
    }, react.createElement(Link/* default */.Z, {
      "data-testid": "item-link",
      href: "".concat(basePath).concat(sub.path)
    }, sub.label));
  }), react.createElement(List/* default.Action */.Z.Action, {
    endIcon: react.createElement(esm/* Icon */.JO$, {
      name: "ChevronRight"
    }),
    onClick: function onClick() {
      return handleClickSideBar();
    }
  }, "Ver todos")), react.createElement(Sidebar/* default */.Z, {
    visible: visible,
    direction: "right",
    fullScreen: true
  }, react.createElement(Sidebar/* default.Header */.Z.Header, {
    icon: "back",
    variant: "primary",
    textAlign: "left",
    onClick: function onClick() {
      return setVisible(false);
    }
  }, category == null ? void 0 : category.label), react.createElement("nav", null, react.createElement(List/* default */.Z, null, subCategoryList && subCategoryList.map(function (sub, index) {
    return react.createElement(List/* default.Item */.Z.Item, {
      key: sub.path,
      url: "".concat(basePath).concat(sub.path),
      fontSize: 1,
      onClick: function onClick(ev) {
        handleClick({
          event: ev,
          subcategory: sub,
          type: 'subcategorylist'
        });
      },
      testId: "sub-category-list-item-".concat(index)
    }, sub.label);
  })))));
}
 false ? 0 : void 0;
SubCategoryList.ssr = true;
SubCategoryList.dataSource = {
  category: {
    query: 'CategoryQuery'
  }
};
/* harmony default export */ var SubCategoryList_SubCategoryList = ((0,withLayoutProps/* default */.Z)(SubCategoryList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SubCategoryList/index.js


/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SummaryTechnicalSheet_SummaryTechnicalSheet; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/index.js + 1 modules
var ProductBundleSelector = __webpack_require__(87757);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SummaryTechnicalSheet/SummaryTechnicalSheet.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4;




var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    px: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text.base',
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var FeaturesList = styled_components_browser_esm["default"].ul(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style-type: disc;\n  padding-left: 10px;\n  margin-left: 10px;\n  li {\n    color: ", ";\n    line-height: 1.6;\n  }\n"])), (0,build_esm.themeGet)('colors.darkSilver'));
var StyledStarGroup = (0,styled_components_browser_esm["default"])(stereo_ui_icons_build_esm/* StarGroup */.rlX)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 8px;\n  color: #0086ff;\n"])));
var WarningGenAI = {
  alignItems: 'center',
  color: '#697277',
  display: 'flex',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  marginBottom: '16px',
  marginTop: '10px'
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SummaryTechnicalSheet/SummaryTechnicalSheet.js









var baseTitle = {
  color: 'base',
  fontSize: 2,
  fontWeight: 'bold',
  lineHeight: 'display',
  my: [2, 2, 2, 2]
};
function SummaryTechnicalSheet(_ref) {
  var _keySellingPoint$item2;
  var data = _ref.data,
    staticProps = _ref.staticProps;
  var product = data.product,
    keySellingPoint = data.keySellingPoint;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
      threshold: 0.5,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  (0,react.useEffect)(function () {
    var _keySellingPoint$item;
    if (inView && (keySellingPoint == null ? void 0 : (_keySellingPoint$item = keySellingPoint.items) == null ? void 0 : _keySellingPoint$item.length)) {
      publish('product:summaryTechnicalSheet');
    }
  }, [inView, keySellingPoint, publish]);
  if (!(keySellingPoint == null ? void 0 : (_keySellingPoint$item2 = keySellingPoint.items) == null ? void 0 : _keySellingPoint$item2.length)) {
    return null;
  }
  return react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "product:active:section",
    eventValue: "product:detail"
  }, react.createElement(Content, {
    ref: ref,
    "data-testid": "technical-sheet-detail"
  }, staticProps.label && react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({}, baseTitle, {
    fontSize: [2, 2, 5, 5],
    fontWeight: "medium",
    "data-testid": "technical-sheet-detail-label",
    as: staticProps.labelAs || 'h2'
  }), staticProps.label), react.createElement(ProductBundleSelector/* default */.Z, {
    data: product
  }), react.createElement(Description, {
    fontSize: [1, 1, 2, 2],
    "data-testid": "technical-sheet-detail-description"
  }, react.createElement(FeaturesList, null, keySellingPoint.items.map(function (feature) {
    return react.createElement("li", {
      key: feature
    }, feature);
  }))), react.createElement("div", {
    style: (0,esm_extends/* default */.Z)({}, WarningGenAI)
  }, react.createElement(StyledStarGroup, null), "Informa\xE7\xF5es geradas pela Lu")));
}
SummaryTechnicalSheet.ssr = true;
SummaryTechnicalSheet.defaultProps = {
  staticProps: {
    label: 'Principais informações deste produto',
    labelAs: 'h2'
  }
};
 false ? 0 : void 0;
/* harmony default export */ var SummaryTechnicalSheet_SummaryTechnicalSheet = (SummaryTechnicalSheet);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SummaryTechnicalSheet/index.js


/***/ }),

/***/ 68500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SupportText_SupportText; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/index.js + 22 modules
var LuContent = __webpack_require__(95949);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/RichDescription/index.js + 2 modules
var RichDescription = __webpack_require__(15439);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SupportText/SupportText.styles.js

var _templateObject;



var ShowMore = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  float: right;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (props) {
  return (0,esm.getTextColor)('primary')(props);
}, (0,esm.themeGet)('fontSizes.2'), (0,esm.themeGet)('space.2'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SupportText/SupportText.js







var defaultImages = {
  blogImage: 'https://wx.mlcdn.com.br/site/shared/lu-content/blog-da-lu.png',
  luExplainImage: 'https://wx.mlcdn.com.br/site/shared/lu-content/lu-explain.png',
  luImage: 'https://wx.mlcdn.com.br/site/shared/lu-content/lu-explains-new.png'
};
var SupportText = function SupportText(_ref) {
  var staticProps = _ref["static"];
  var _ref2 = staticProps || {},
    content = _ref2.content,
    preview = _ref2.preview,
    title = _ref2.title,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'center' : _ref2$direction,
    _ref2$images = _ref2.images,
    images = _ref2$images === void 0 ? defaultImages : _ref2$images;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openDialog = _useState2[0],
    setOpenDialog = _useState2[1];
  var handleClickClose = function handleClickClose() {
    return setOpenDialog(false);
  };
  var handleClickOpen = function handleClickOpen() {
    return setOpenDialog(true);
  };
  return preview && react.createElement(Box/* default */.Z, {
    marginY: 4,
    paddingY: 4,
    paddingX: 2,
    borderTopWidth: 1,
    borderTopColor: "whisper",
    borderTopStyle: "solid"
  }, react.createElement(RichDescription/* default */.Z, {
    "static": {
      fontSize: 2,
      lineHeight: '1.3em',
      richContent: preview
    }
  }), content && react.createElement(react.Fragment, null, react.createElement(ShowMore, {
    as: "a",
    role: "button",
    onClick: handleClickOpen,
    "data-testid": "support-text-link"
  }, "Continuar lendo..."), react.createElement(LuContent/* LuContentContext */.fh, null, react.createElement(LuContent/* LuDetail */.X6, {
    visible: openDialog,
    onBackButtonClick: handleClickClose,
    images: images,
    direction: direction,
    content: content,
    subtitle: title
  }))));
};
 false ? 0 : void 0;
SupportText.defaultProps = {
  "static": {}
};
SupportText.ssr = true;
/* harmony default export */ var SupportText_SupportText = (SupportText);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SupportText/index.js


/***/ })

}]);